// extracted by mini-css-extract-plugin
module.exports = {"root":"SideFiltersFormFooter_root__CSLxV","button":"SideFiltersFormFooter_button___IvHq","filterButtons":"SideFiltersFormFooter_filterButtons__sAPPp"};